import { IHashmap } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

/**
 * Create initial configuration state to set which column will be sorted desc
 * @param {Object} params - The parameters object
 * @param {Array} params.generatedCols - The generated columns array
 * @param {string} params.parsedCheck - The parsed check string
 * @return {{hiddenColumns: Array, sortBy: Array}} The initial state configuration
 */
export const initialStateHelper = ({ generatedCols, parsedCheck }) => {
    const defaultState = {
        hiddenColumns: [],
        sortBy: [],
    };

    if (parsedCheck.toLowerCase() === 'work settings applied') {
        return defaultState;
    }

    if (!generatedCols) {
        return defaultState;
    }

    const colorableItem = generatedCols.find((i) => i.colorable);
    if (!colorableItem) {
        return defaultState;
    }

    return {
        hiddenColumns: [],
        sortBy: [
            {
                id: colorableItem.accessorKey,
                desc: true,
            },
        ],
    };
};

/**
 * Maps a Logic Quality validation title (e.g. "Out of Sequence")
 * to its corresponding component key (e.g. "outOfSequence") in order to be added to report.
 *
 * Returns:
 * The corresponding component key if it exists (e.g. "outOfSequence")
 */
export const logicQualityTitleToComponentKeyMap: Record<string, keyof IHashmap> = {
    'Out Of Sequence': 'outOfSequence',
    'Dangling Logic': 'danglingLogic',
    Leads: 'leads',
    Lags: 'lags',
    'Relationship Types': 'relationshipTypes',
    'Hard Constraints': 'hardConstraints',
    'High Float by Activity Type': 'highFloatByActivityType',
    'Negative Float by Activity Type': 'negativeFloatByActivityType',
    'Long Duration': 'longDuration',
    'Invalid Actual Dates': 'invalidActualDates',
    'Invalid Forecast Dates': 'invalidForecastDates',
    'Unresourced Activities': 'unresourcedActivities',
    'Missed Activities': 'missedActivities',
    'Critical Path Test': 'criticalPathTest',
    'Critical Path Length Index': 'criticalPathLengthIndex',
    'Baseline Execution Index': 'baselineExecutionIndex',
    'Missing Baseline Dates': 'missingBaselineDates',
    'Duplicate Relations': 'duplicateRelations',
    'Soft Constraints': 'softConstraints',
    'Critical Path Congestion': 'criticalPathCongestion',
    'Incomplete With Finish Date': 'incompleteWithFinishDate',
    'Constraints Without Relationship': 'constraintsWithoutRelationship',
    'Sensitive Activities by Duration': 'sensitiveActivitiesByDuration',
    'Work Settings Applied': 'workSettingsApplied',
    'Start/Finish Time Not Round': 'startFinishTimeNotRound',
    'Activities With Early Finish Time': 'activitiesWithEarlyFinishTime',
    'Activities With Late Start Time': 'activitiesWithLateStartTime',
    'Frequently Used Resources': 'frequentlyUsedResources',
    'Rarely Used Resources': 'rarelyUsedResources',
    'Relationships/Activities Ratio': 'relationshipsActivitiesRatio',
};

export const getComponentKeyByTitle = (check: string | undefined) => {
    return logicQualityTitleToComponentKeyMap[check ?? ''];
};
